import { render, staticRenderFns } from "./WordpressApiKey.vue?vue&type=template&id=af63881a&scoped=true&"
import script from "./WordpressApiKey.vue?vue&type=script&lang=js&"
export * from "./WordpressApiKey.vue?vue&type=script&lang=js&"
import style0 from "./WordpressApiKey.vue?vue&type=style&index=0&id=af63881a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af63881a",
  null
  
)

export default component.exports